import React from 'react';
import Legal from '../Legal';
import InfoModalTxt from '../modal_txt/InfoModalTxt';
import LargeModalTxt from '../modal_txt/LargeModalTxt'


export default function LargeModal(props, { handler }) {
    const [showModal, setShowModal] = React.useState(false);
    return (
        <>
            {props.title !== undefined &&
            
            <span onClick={() => setShowModal(true)}><svg className = "align-text-bottom inline-flex content-end font-light w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-1 -5 32 32" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
            </svg>
        
            </span>
            }
            {showModal ? (
                <div>
                    <div className="z-50 fixed top-0 left-0 flex items-center justify-center w-full h-full outline-none overflow-x-hidden overflow-y-auto"
                        id="exampleModalScrollable" tabIndex="-1" aria-labelledby="exampleModalScrollableLabel" aria-hidden="true">
                        <div className="max-w-lg my-6 mx-auto w-auto pointer-events-none">
                            <div className="max-h-full overflow-hidden border-none shadow-lg flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                                {/*content*/}
                                <div className="flex-auto overflow-y-auto text-black relative p-4">
                                    <LargeModalTxt title = {props.title} desc = {props.desc}/>
                                </div>
                                <div className="relative p-6 flex-auto">

                                    <button
                                        className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                        type="button"
                                        onClick={() => setShowModal(false)}
                                    >
                                        Close
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-60 fixed inset-0 z-40 bg-black flex-1"></div>
                </div>
            ) : null}
        </>
    );
}